import styled from 'styled-components/macro';

const ConditionSetItem = styled('div')`
  display: flex;
  flex-direction: column;
  padding-right: 20px;
`;

export default ConditionSetItem;
